export function cleanTitleForComparison(str: string): string {
  return removeAccents(str.toLowerCase());
}

function removeAccents(str: string): string {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
